<template>
    <div>Logout</div>
</template>

<script>    
    const Logout = {
        name: 'Logout',
        beforeMount: function(){
            sessionStorage.clear()
            this.$router.push({name:'login'})
        }
    }

    export default Logout
</script>